import { IObservable, Observable } from '@1js/oil-externals/rx';
import { OfficeRoute } from '../../shared/constants/office-route.enum';
import { FileItem, FileType } from '../../shared/models/file-item.model';
import { SearchResultType } from '../search-instrumentation.service';
import { BaseSuggestionProvider } from './base.search-suggestion-provider';

export class AppSuggestionProvider extends BaseSuggestionProvider {

    public static allApps: Array<object>;
    private static readonly zeroTermDefaultAppList: Array<string> = ['ShellWordOnline', 'ShellPowerPointOnline', 'ShellExcelOnline', 'ShellMail'];
    private static readonly zeroTermWordAppList: Array<string> = ['ShellPowerPointOnline', 'ShellExcelOnline', 'ShellMail', 'ShellCalendar'];
    private static readonly zeroTermPPTAppList: Array<string> = ['ShellWordOnline', 'ShellExcelOnline', 'ShellMail', 'ShellCalendar'];
    private static readonly zeroTermExcelAppList: Array<string> = ['ShellWordOnline', 'ShellPowerPointOnline', 'ShellMail', 'ShellOfficeForms'];
    private static readonly zeroTermAppResults: Array<object> = new Array(AppSuggestionProvider.zeroTermDefaultAppList.length);
    private currentRoute: OfficeRoute;

    public createStream(searchText: string): IObservable<any> {

        const MAXCOUNT: number = 3;
        const apps: Array<object> = [];
        const renderedResults: Array<string> = [];
        let result: Array<object> = [];

        if (searchText?.trim() === '') {
            if (this.currentRoute === undefined || this.currentRoute !== AppSuggestionProvider.currentRoute.route) {
                const appList: Array<string> = this.getAppList(AppSuggestionProvider.currentRoute.route, AppSuggestionProvider.currentRoute.app);
                AppSuggestionProvider.allApps.forEach(app => {
                    if (appList.includes(app['Id'])) {
                        AppSuggestionProvider.zeroTermAppResults[appList.indexOf(app['Id'])] = app;
                    }
                });
                this.currentRoute = AppSuggestionProvider.currentRoute.route;
            }
            result = AppSuggestionProvider.zeroTermAppResults;
        } else {
            const text: string = searchText.toLowerCase();

            AppSuggestionProvider.allApps.forEach(app => {
                const name: string = app['Title'].toLowerCase();
                if (AppSuggestionProvider.currentRoute.route === OfficeRoute.Start && FileItem.fileTypeNameFromType(AppSuggestionProvider.currentRoute.app).toLowerCase() === name) {
                    return;
                }
                if (text.indexOf(name) === 0 || name.indexOf(text) === 0) {
                    result.push(app);
                    if (result.length === MAXCOUNT) {
                        return false;
                    }
                }
            });
        }

        result.forEach(app => {
            apps.push({
                id: app['Id'],
                isPwa: AppSuggestionProvider.capabilitiesService.capabilities.isPwaInUwp,
                isDarkMode: AppSuggestionProvider.isDarkMode,
                title: app['Title'],
                iconClass: app['IconUnicodeCodepointCssClass'],
                url: app['Url'],
                referral: app['Referral'],
                searchInstrumentationService: AppSuggestionProvider.searchInstrumentationService,
                sharedSearchService: AppSuggestionProvider.sharedSearchService
            });

            renderedResults.push(app['Title']);
        });

        AppSuggestionProvider.searchInstrumentationService.setRenderedProviderResults(SearchResultType.App, renderedResults);
        return Observable.fromArray(apps);
    }

    public getId(): string {
        return 'apps';
    }

    private getAppList(app: OfficeRoute, fileType: FileType): Array<string> {
        if (app === OfficeRoute.Start) {
            switch (fileType) {
                case FileType.Word:
                    return AppSuggestionProvider.zeroTermWordAppList;
                case FileType.Excel:
                    return AppSuggestionProvider.zeroTermExcelAppList;
                case FileType.PowerPoint:
                    return AppSuggestionProvider.zeroTermPPTAppList;
            }
        }

        return AppSuggestionProvider.zeroTermDefaultAppList;
    }
}
